import React, { useState } from "react";
import GenericSelectableTable from "../selectableTable";
import { Link } from "react-router-dom";
import { NXDelete, NXEditPen } from "../../icons";
import { useDeleteConfirmation } from "../common";
import useApi from "../../api";
import SupplierForm from "./SupplierForm";
import { toast } from "react-toastify";



interface SupplierTableProps {
  data: any;
  refresh:()=>void;
}

function SupplierTable({ data, refresh }: SupplierTableProps) {
  const api = useApi();
  const { handleDelete } = useDeleteConfirmation();
  const [edit, setEdit] = useState<any>(null)


  const columns = [
    {
      header: "ID",
      key: "id",
      render: (item: any) => (
        <Link to={item.id}>
          <p>{item.id}</p>
          <p className="text-sm font-normal text-base-300 mt-1">#ID{item.id}</p>
        </Link>
      ),
    },
    { header: "Name", key: "name" },
    { header: "Description", key: "description" },
    { header: "Action", key: "", render: (item: any)=>(
      <div className="flex gap-1 items-center">
        <button
          className="p-1"
          onClick={() => {
            handleDelete(
              item.id,
              "Supplier",
              api.deleteSupplier,
              refresh
            );
          }}
        >
          <NXDelete className="text-red-600" />
        </button>
        <button className="p-1" onClick={(e: any) => setEdit(item)}>
          <NXEditPen />
        </button>
      </div>
    )}
  ];


  return (
    <div className="overflow-x-auto">
      <GenericSelectableTable
        columns={columns}
        data={data?.results || []}
      />
      <SupplierForm isOpen={edit ? true : false } onClose={()=>setEdit(null)} edit={edit} refresh={refresh}/>
    </div>
  );
}

export default SupplierTable;
